(function (app) {
    app.provider("figDotComApi", [function () {
        this.$get = ["portalApiGateway", function (portalApiGateway) {
            var service = {};

            service.getSurvey = function (surveyId) {
                return portalApiGateway.get("/FigDotCom/" + surveyId);
            };                     

            service.submit = function (surveyId, answers) {
                console.log(answers)
                return portalApiGateway.post("/FigDotCom/" + surveyId + "/Answers", answers);
            };

            service.getSalesConsultants = function () {
                return portalApiGateway.getArray("/FigDotCom/SalesConsultants");
            };

            return service;
        }];
    }]);
})(window.app); // jshint ignore:line